import React from 'react';

import { Flex, Loader } from '@betterment/style-closet-react';

export const FullPageLoader: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Flex height="100vh">
    <Loader isLoading={true} />
  </Flex>
);
